<template>
  <div class="opinion_w site_content">

    <div class="layout_card">
      <h3 class="fz24 font_w_bold text_center" style="margin: 0 0 50px 0">批前公示反馈意见表</h3>

      <div class="card_w">
        <div class="card_h">公示信息</div>
        <div class="card_c">
          <el-descriptions title="" :column="2" border style="margin:20px 0 20px 0">
            <el-descriptions-item label="项目名称">{{
              projectInfo.title
            }}</el-descriptions-item>
          </el-descriptions>
        </div>
      </div>

      <div class="card_w">
        <div class="card_h">反馈人信息</div>
        <div class="card_c">
          <el-form ref="feedbackForm" label-width="130px" :model="publicForm" :rules="rules">
            <el-form-item label="姓名" class="" prop="username">
              <el-input v-model="publicForm.username" show-word-limit :maxlength="input_l_50" />
            </el-form-item>
            <el-form-item label="联系电话" class="" prop="phone">
              <el-input v-model="publicForm.phone" />
            </el-form-item>
            <el-form-item label="联系地址" class=" word_limit_300" prop="addr">
              <el-input v-model="publicForm.addr" show-word-limit :maxlength="input_l_300" />
            </el-form-item>
            <el-form-item label="邮政编码" class="" prop="postcode">
              <el-input v-model="publicForm.postcode" :maxlength="input_l_50" show-word-limit />
            </el-form-item>
            <el-form-item label="反馈意见" class=" " prop="remark">
              <el-input v-model="publicForm.remark" show-word-limit :maxlength="input_l_500" type="textarea" :autosize="{ minRows: 7, }" />
            </el-form-item>
          </el-form>
        </div>
      </div>

      <div class="text_center">
        <el-button size="small" type="primary" @click="onSubmit">提交意见</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { cms_article_info } from '@/api/portal'
import { validatePhone } from '@/utils/validFiled'
import { feedback_submit } from '@/api/public'
import { _input_l_500, _input_l_50,
  _input_l_100,
  _input_l_150,
  _input_l_300 } from '@/utils/setting'
export default {
  data() {
    // 有效手机号
    const checkPhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号'))
      } else if (!validatePhone(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    return {
      rules: {
        remark: [
          { required: true, message: '请输入反馈内容', trigger: 'change' }
        ],
        username: [
          { required: true, message: '请输入姓名', trigger: 'change' }
        ],
        phone: [
          { required: true, trigger: 'blur', validator: checkPhone }
        ],
        addr: [
          { required: true, message: '请输入联系地址', trigger: 'change' }
        ]
        // postcode: [
        //   { required: true, message: '请输入邮政编码', trigger: 'change' }
        // ]
      },
      publicForm: {},
      projectInfo: {},
      feedbackInfo: {
        title: '111111111111',
        tradeMode: '22222222222'
      } // 反馈人信息
    }
  },

  computed: {
    input_l_50() {
      return _input_l_50
    },
    input_l_100() {
      return _input_l_100
    },
    input_l_300() {
      return _input_l_300
    },
    input_l_500() {
      return _input_l_500
    }
  },

  created() {
    console.log(this.$route)
    const { id } = this.$route.query
    this.publicForm.articleId = id
    this.getNoticeInfo(id)
  },
  methods: {
    // 获取公示信息
    async getNoticeInfo(id) {
      const { data } = await cms_article_info({
        id: id
      })
      this.projectInfo = data
      this.publicForm.title = data.title
    },

    async onSubmit() {
      let feedbackValid = false
      this.$refs.feedbackForm.validate(valid => {
        feedbackValid = valid
      })

      if (feedbackValid) {
        const res = await feedback_submit(this.publicForm)
        if (res.code === 200) {
          this.$notify({
            type: 'success',
            message: '提交成功'
          })
          this.$router.go(-1)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.opinion_w{
    padding: 50px 0;
    ::v-deep .el-form-item__label{
        font-size: 16px;
    }
}
</style>
